// extracted by mini-css-extract-plugin
export default {"code":"Code_code__yKXOX","compact":"Code_compact__Ow86O","isHidden":"Code_isHidden__Hu+u7"};